/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_Section_SummaryInputs */



/**
* | output |
* | --- |
* | "Summary Tab" |
*
* @param {Options_Metrics_Section_SummaryInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_section_summary = /** @type {((inputs?: Options_Metrics_Section_SummaryInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_Section_SummaryInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Summary Tab")
	if (locale === "de") return /** @type {LocalizedString} */ ("Summary Tab")
	if (locale === "it") return /** @type {LocalizedString} */ ("Summary Tab")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Summary Tab")
	if (locale === "es") return /** @type {LocalizedString} */ ("Summary Tab")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Summary Tab")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Summary Tab")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Summary Tab")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Summary Tab")
	return /** @type {LocalizedString} */ ("Summary Tab")
});